import {
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  QuartoService,
  Quarto
} from '../../../service/quarto.service';

import Swal from 'sweetalert2';


@Component({
  selector: 'app-dashboard',

  standalone: true,

  imports: [
    CommonModule
  ],

  templateUrl: './dashboard.component.html',

  styleUrls: [
    './dashboard.component.css'
  ]
})
export class DashboardComponent
  implements OnInit {

  quartos: Quarto[] = [];

  carregando = false;


  constructor(
    private quartoService: QuartoService,
    private cdr: ChangeDetectorRef
  ) {}


  ngOnInit(): void {

    this.carregarQuartos();

  }


  carregarQuartos(): void {

    this.carregando = true;

    this.quartoService
      .listar()
      .subscribe({

        next: (quartos) => {

          this.quartos = quartos;

          this.carregando = false;

          this.cdr.detectChanges();

        },

        error: (erro) => {

          this.carregando = false;

          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível carregar as acomodações.'
          });

        }

      });

  }


  get quartosDisponiveis(): number {

    return this.quartos.filter(
      quarto =>
        quarto.status === 'DISPONIVEL'
    ).length;

  }


  get quartosIndisponiveis(): number {

    return this.quartos.filter(
      quarto =>
        quarto.status !== 'DISPONIVEL'
    ).length;

  }

}
